export default __webpack_public_path__ + "static/media/cama-premium.74890cab.svg";